import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { service } from "@ember/service";
import { Task, task } from "ember-concurrency";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { not } from "ember-truth-helpers";
import { shape, instanceOf } from "prop-types";
import { on } from "@ember/modifier";
import { t } from "ember-intl";
import ShipmentModel from "glesys-controlpanel/models/shipment";
import Header from "glesys-controlpanel/components/g-modal/header";
import Body from "glesys-controlpanel/components/g-modal/body";
import Footer from "glesys-controlpanel/components/g-modal/footer";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import GButton from "glesys-controlpanel/components/g-button";
import TaskForm from "glesys-controlpanel/components/task-form";
import Label from "glesys-controlpanel/components/label";
import GInput from "glesys-controlpanel/components/g-input";

@forbidExtraArgs
export default class ModalsEditShipment extends Component {
  @service modal;

  @arg(
    shape({
      shipment: instanceOf(ShipmentModel),
      submitTask: instanceOf(Task),
    }).isRequired,
  )
  params;

  @tracked trackingId = this.params.shipment.trackingid;

  onFormChange = ({ trackingId }) => {
    this.trackingId = trackingId;
  };

  get canSubmit() {
    return this.trackingId?.trim();
  }

  onSubmitTask = task(async () => {
    await this.params.submitTask.perform(this.trackingId.trim());

    this.modal.close();
  });

  <template>
    <Header>{{t "component.modal.edit-shipment.title"}}</Header>
    <Body data-test-edit-shipment-modal>
      <p class="text-gray-800 pb-6">
        {{t "component.modal.edit-shipment.description"}}
      </p>
      <TaskForm id="edit-shipment-form" @onChange={{this.onFormChange}} @task={{this.onSubmitTask}}>
        <div>
          <Label for="trackingId">{{t "label.tracking-id"}}</Label>
          <GInput
            data-test-edit-shipment-modal-tracking-id
            name="trackingId"
            value={{this.trackingId}}
            placeholder={{t "component.modal.create-shipment.tracking-id-placeholder"}}
          />
        </div>
      </TaskForm>
    </Body>
    <Footer>
      <GButton class="mr-2" data-test-cancel-button @color="gray" {{on "click" (modalClose)}}>
        {{t "button.close"}}
      </GButton>
      <GButton
        data-test-edit-shipment-submit
        @type="submit"
        @color="blue"
        @disabled={{not this.canSubmit}}
        form="edit-shipment-form"
      >
        {{t "button.save"}}
      </GButton>
    </Footer>
  </template>
}
